import React from 'react';
import {
	Button,
	Checkbox,
	Form,
	Icon,
	Input,
	message,
	Dropdown,
	DatePicker,
	Menu,
	Upload,
	Select,
	Col,
	Layout,
	Row
} from 'antd';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import * as moment from 'moment';
import { auth, database } from '../firebase/firebase';
import HorizontalDefault from "./Topbar/HorizontalDefault/index";
import Moment from "moment";
import {version} from "util/config";

import { connect } from 'react-redux';
import {
	hideMessage,
	showAuthLoader,
	userFacebookSignIn,
	userGithubSignIn,
	userGoogleSignIn,
	userSignUp,
	userSignIn,
	userTwitterSignIn
} from 'appRedux/actions/Auth';

import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress/index';


const FormItem = Form.Item;
const Option = Select.Option;

function getBase64(img, callback) {
	const reader = new FileReader();
	reader.addEventListener('load', () => callback(reader.result));
	reader.readAsDataURL(img);
}

function beforeUpload(file) {
	const isJPG = file.type === 'image/jpeg';
	if (!isJPG) {
		message.error('You can only upload JPG file!');
	}
	const isLt2M = file.size / 1024 / 1024 < 2;
	if (!isLt2M) {
		message.error('Image must smaller than 2MB!');
	}
	return isJPG && isLt2M;
}

class SignUp extends React.Component {
	handleChange = (info) => {
		if (info.file.status === 'uploading') {
			this.setState({ loading: true });
			return;
		}
		if (info.file.status === 'done') {
			// Get this url from response in real world.
			getBase64(info.file.originFileObj, (imageUrl) =>
				this.setState({
					imageUrl,
					loading: false
				})
			);
		}
	};
	handleSexClick(e) {
		//console.log(e);
		//console.log(e);
		this.setState({ sex: e });
	}
	handleStateClick(e) {
		this.setState({ state: e });
	}

	setRedirect = () => {
		this.setState({
			redirect: true
		});
	};
	renderRedirect = () => {
		if (this.state.redirect) {
			return <Redirect to="/profile" />;
		}
	};

	handleSignIn = (err, values) => {
		//console.log('data');
		//console.log(err);
		//console.log(values);
		if (!err) {
			var _this = this;
			var codes = [
				"PCM-SIEGFRIED",
"PCM-SIEGFRIED1",
"PCM-SIEGFRIED2",
"PCM-SIEGFRIED3",
"PCM-SIEGFRIED4",
"PCM-SIEGFRIED5",
"PCM-SIEGFRIED6",
"PCM-SIEGFRIED7",
"PCM-SIEGFRIED8",
"PCM-SIEGFRIED9",
"PCM-SIEGFRIED10",
"PCM-SIEGFRIED11",
"PCM-SIEGFRIED12",
"PCM-SIEGFRIED13",
"PCM-SIEGFRIED14",
"PCM-SIEGFRIED15",
"PCM-SIEGFRIED16",
"PCM-SIEGFRIED17",
"PCM-SIEGFRIED18",
"PCM-SIEGFRIED19",
"PCM-SIEGFRIED20",
"PCM-SIEGFRIED21",
"PCM-SIEGFRIED22",
"PCM-SIEGFRIED23",
"PCM-SIEGFRIED24",
"PCM-SIEGFRIED25",
"PCM-SIEGFRIED26",
"PCM-SIEGFRIED27",
"PCM-SIEGFRIED28",
"PCM-SIEGFRIED29",
"PCM-SIEGFRIED30",
"PCM-SIEGFRIED31",
"PCM-SIEGFRIED32",
"PCM-SIEGFRIED33",
"PCM-SIEGFRIED34",
"PCM-SIEGFRIED35",
"PCM-SIEGFRIED36",
"PCM-SIEGFRIED37",
"PCM-SIEGFRIED38",
"PCM-SIEGFRIED39",
"PCM-SIEGFRIED40",
"PCM-SIEGFRIED41",
"PCM-SIEGFRIED42",
"PCM-SIEGFRIED43",
"PCM-SIEGFRIED44",
"PCM-SIEGFRIED45",
"PCM-SIEGFRIED46",
"PCM-SIEGFRIED47",
"PCM-SIEGFRIED48",
"PCM-SIEGFRIED49",
"PCM-SIEGFRIED50",
"PCM-SIEGFRIED51",
"PCM-SIEGFRIED52",
"PCM-SIEGFRIED53",
"PCM-SIEGFRIED54",
"PCM-SIEGFRIED55",
"PCM-SIEGFRIED56",
"PCM-SIEGFRIED57",
"PCM-SIEGFRIED58",
"PCM-SIEGFRIED59",
"PCM-SIEGFRIED60",
"PCM-SIEGFRIED61",
"PCM-SIEGFRIED62",
"PCM-SIEGFRIED63",
"PCM-SIEGFRIED64",
"PCM-SIEGFRIED65",
"PCM-SIEGFRIED66",
"PCM-SIEGFRIED67",
"PCM-SIEGFRIED68",
"PCM-SIEGFRIED69",
"PCM-SIEGFRIED70",
"PCM-SIEGFRIED71",
"PCM-SIEGFRIED72",
"PCM-SIEGFRIED73",
"PCM-SIEGFRIED74",
"PCM-SIEGFRIED75",
"PCM-SIEGFRIED76",
"PCM-SIEGFRIED77",
"PCM-SIEGFRIED78",
"PCM-SIEGFRIED79",
"PCM-SIEGFRIED80",
"PCM-SIEGFRIED81",
"PCM-SIEGFRIED82",
"PCM-SIEGFRIED83",
"PCM-SIEGFRIED84",
"PCM-SIEGFRIED85",
"PCM-SIEGFRIED86",
"PCM-SIEGFRIED87",
"PCM-SIEGFRIED88",
"PCM-SIEGFRIED89",
"PCM-SIEGFRIED90",
"PCM-SIEGFRIED91",
"PCM-SIEGFRIED92",
"PCM-SIEGFRIED93",
"PCM-SIEGFRIED94",
"PCM-SIEGFRIED95",
"PCM-SIEGFRIED96",
"PCM-SIEGFRIED97",
"PCM-SIEGFRIED98",
"PCM-SIEGFRIED99",
"PCM-SIEGFRIED100",
"PCM-SIEGFRIED101",
"PCM-SIEGFRIED102",
"PCM-SIEGFRIED103",
"PCM-SIEGFRIED104",
"PCM-SIEGFRIED105",
"PCM-SIEGFRIED106",
"PCM-SIEGFRIED107",
"PCM-SIEGFRIED108",
"PCM-SIEGFRIED109",
"PCM-SIEGFRIED110",
"PCM-SIEGFRIED111",
"PCM-SIEGFRIED112",
"PCM-SIEGFRIED113",
"PCM-SIEGFRIED114",
"PCM-SIEGFRIED115",
"PCM-SIEGFRIED116",
"PCM-SIEGFRIED117",
"PCM-SIEGFRIED118",
"PCM-SIEGFRIED119",
"PCM-SIEGFRIED120",
"PCM-SIEGFRIED121",
"PCM-SIEGFRIED122",
"PCM-SIEGFRIED123",
"PCM-SIEGFRIED124",
"PCM-SIEGFRIED125",
"PCM-SIEGFRIED126",
"PCM-SIEGFRIED127",
"PCM-SIEGFRIED128",
"PCM-SIEGFRIED129",
"PCM-SIEGFRIED130",
"PCM-SIEGFRIED131",
"PCM-SIEGFRIED132",
"PCM-SIEGFRIED133",
"PCM-SIEGFRIED134",
"PCM-SIEGFRIED135",
"PCM-SIEGFRIED136",
"PCM-SIEGFRIED137",
"PCM-SIEGFRIED138",
"PCM-SIEGFRIED139",
"PCM-SIEGFRIED140",
"PCM-SIEGFRIED141",
"PCM-SIEGFRIED142",
"PCM-SIEGFRIED143",
"PCM-SIEGFRIED144",
"PCM-SIEGFRIED145",
"PCM-SIEGFRIED146",
"PCM-SIEGFRIED147",
"PCM-SIEGFRIED148",
"PCM-SIEGFRIED149",
"PCM-SIEGFRIED150",
"PCM-SIEGFRIED151",
"PCM-SIEGFRIED152",
"PCM-SIEGFRIED153",
"PCM-SIEGFRIED154",
"PCM-SIEGFRIED155",
"PCM-SIEGFRIED156",
"PCM-SIEGFRIED157",
"PCM-SIEGFRIED158",
"PCM-SIEGFRIED159",
"PCM-SIEGFRIED160",
"PCM-SIEGFRIED161",
"PCM-SIEGFRIED162",
"PCM-SIEGFRIED163",
"PCM-SIEGFRIED164",
"PCM-SIEGFRIED165",
"PCM-SIEGFRIED166",
"PCM-SIEGFRIED167",
"PCM-SIEGFRIED168",
"PCM-SIEGFRIED169",
"PCM-SIEGFRIED170",
"PCM-SIEGFRIED171",
"PCM-SIEGFRIED172",
"PCM-SIEGFRIED173",
"PCM-SIEGFRIED174",
"PCM-SIEGFRIED175",
"PCM-SIEGFRIED176",
"PCM-SIEGFRIED177",
"PCM-SIEGFRIED178",
"PCM-SIEGFRIED179",
"PCM-SIEGFRIED180",
"PCM-SIEGFRIED181",
"PCM-SIEGFRIED182",
"PCM-SIEGFRIED183",
"PCM-SIEGFRIED184",
"PCM-SIEGFRIED185",
"PCM-SIEGFRIED186",
"PCM-SIEGFRIED187",
"PCM-SIEGFRIED188",
"PCM-SIEGFRIED189",
"PCM-SIEGFRIED190",
"PCM-SIEGFRIED191",
"PCM-SIEGFRIED192",
"PCM-SIEGFRIED193",
"PCM-SIEGFRIED194",
"PCM-SIEGFRIED195",
"PCM-SIEGFRIED196",
"PCM-SIEGFRIED197",
"PCM-SIEGFRIED198",
"PCM-SIEGFRIED199",
"PCM-SIEGFRIED200",
"PCM-SIEGFRIED201",
"PCM-SIEGFRIED202",
"PCM-SIEGFRIED203",
"PCM-SIEGFRIED204",
"PCM-SIEGFRIED205",
"PCM-SIEGFRIED206",
"PCM-SIEGFRIED207",
"PCM-SIEGFRIED208",
"PCM-SIEGFRIED209",
"PCM-SIEGFRIED210",
"PCM-SIEGFRIED211",
"PCM-SIEGFRIED212",
"PCM-SIEGFRIED213",
"PCM-SIEGFRIED214",
"PCM-SIEGFRIED215",
"PCM-SIEGFRIED216",
"PCM-SIEGFRIED217",
"PCM-SIEGFRIED218",
"PCM-SIEGFRIED219",
"PCM-SIEGFRIED220",
"PCM-SIEGFRIED221",
"PCM-SIEGFRIED222",
"PCM-SIEGFRIED223",
"PCM-SIEGFRIED224",
"PCM-SIEGFRIED225",
"PCM-SIEGFRIED226",
"PCM-SIEGFRIED227",
"PCM-SIEGFRIED228",
"PCM-SIEGFRIED229",
"PCM-SIEGFRIED230",
"PCM-SIEGFRIED231",
"PCM-SIEGFRIED232",
"PCM-SIEGFRIED233",
"PCM-SIEGFRIED234",
"PCM-SIEGFRIED235",
"PCM-SIEGFRIED236",
"PCM-SIEGFRIED237",
"PCM-SIEGFRIED238",
"PCM-SIEGFRIED239",
"PCM-SIEGFRIED240",
"PCM-SIEGFRIED241",
"PCM-SIEGFRIED242",
"PCM-SIEGFRIED243",
"PCM-SIEGFRIED244",
"PCM-SIEGFRIED245",
"PCM-SIEGFRIED246",
"PCM-SIEGFRIED247",
"PCM-SIEGFRIED248",
"PCM-SIEGFRIED249",
"PCM-SIEGFRIED250",
"PCM-SIEGFRIED251",
"PCM-SIEGFRIED252",
"PCM-SIEGFRIED253",
"PCM-SIEGFRIED254",
"PCM-SIEGFRIED255",
"PCM-SIEGFRIED256",
"PCM-SIEGFRIED257",
"PCM-SIEGFRIED258",
"PCM-SIEGFRIED259",
"PCM-SIEGFRIED260",
"PCM-SIEGFRIED261",
"PCM-SIEGFRIED262",
"PCM-SIEGFRIED263",
"PCM-SIEGFRIED264",
"PCM-SIEGFRIED265",
"PCM-SIEGFRIED266",
"PCM-SIEGFRIED267",
"PCM-SIEGFRIED268",
"PCM-SIEGFRIED269",
"PCM-SIEGFRIED270",
"PCM-SIEGFRIED271",
"PCM-SIEGFRIED272",
"PCM-SIEGFRIED273",
"PCM-SIEGFRIED274",
"PCM-SIEGFRIED275",
"PCM-SIEGFRIED276",
"PCM-SIEGFRIED277",
"PCM-SIEGFRIED278",
"PCM-SIEGFRIED279",
"PCM-SIEGFRIED280",
"PCM-SIEGFRIED281",
"PCM-SIEGFRIED282",
"PCM-SIEGFRIED283",
"PCM-SIEGFRIED284",
"PCM-SIEGFRIED285",
"PCM-SIEGFRIED286",
"PCM-SIEGFRIED287",
"PCM-SIEGFRIED288",
"PCM-SIEGFRIED289",
"PCM-SIEGFRIED290",
"PCM-SIEGFRIED291",
"PCM-SIEGFRIED292",
"PCM-SIEGFRIED293",
"PCM-SIEGFRIED294",
"PCM-SIEGFRIED295",
"PCM-SIEGFRIED296",
"PCM-SIEGFRIED297",
"PCM-SIEGFRIED298",
"PCM-SIEGFRIED299",
"PCM-SIEGFRIED300",
"PCM-SIEGFRIED301",
"PCM-SIEGFRIED302",
"IS001",
"IS002",
"IS003",
"IS004",
"IS005",
"IS006",
"IS007",
"IS008",
"IS009",
"IS010",
"IS011",
"IS012",
"IS013",
"IS014",
"IS015",
"IS016",
"IS017",
"IS018",
"IS019",
"IS020",
"IS021",
"IS022",
"IS023",
"IS024",
"IS025",
"IS026",
"IS027",
"IS028",
"IS029",
"IS030",
"IS031",
"IS032",
"IS033",
"IS034",
"IS035",
"IS036",
"IS037",
"IS038",
"IS039",
"IS040",
"IS041",
"IS042",
"IS043",
"IS044",
"IS045",
"IS046",
"IS047",
"IS048",
"IS049",
"IS050",
"MX001",
"MX002",
"MX003",
"MX004",
"MX005",
"MX006",
"MX007",
"MX008",
"MX009",
"MX010",
"MX011",
"MX012",
"MX013",
"MX014",
"MX015",
"MX016",
"MX017",
"MX018",
"MX019",
"MX020",
"MX021",
"MX022",
"MX023",
"MX024",
"MX025",
"MX026",
"MX027",
"MX028",
"MX029",
"MX030",
"MX031",
"MX032",
"MX033",
"MX034",
"MX035",
"MX036",
"MX037",
"MX038",
"MX039",
"MX040",
"MX041",
"MX042",
"MX043",
"MX044",
"MX045",
"MX046",
"MX047",
"MX048",
"MX049",
"MX050",
"MX051",
"MX052",
"MX053",
"MX054",
"MX055",
"MX056",
"MX057",
"MX058",
"MX059",
"MX060",
"MX061",
"MX062",
"MX063",
"MX064",
"MX065",
"MX066",
"MX067",
"MX068",
"MX069",
"MX070",
"MX071",
"MX072",
"MX073",
"MX074",
"MX075",
"MX076",
"MX077",
"MX078",
"MX079",
"MX080",
"MX081",
"MX082",
"MX083",
"MX084",
"MX085",
"MX086",
"MX087",
"MX088",
"MX089",
"MX090",
"MX091",
"MX092",
"MX093",
"MX094",
"MX095",
"MX096",
"MX097",
"MX098",
"MX099",
"MX100",
"MX101",
"MX102",
"MX103",
"MX104",
"MX105",
"MX106",
"MX107",
"MX108",
"MX109",
"MX110",
"MX111",
"MX112",
"MX113",
"MX114",
"MX115",
"MX116",
"MX117",
"MX118",
"MX119",
"MX120",
"MX121",
"MX122",
"MX123",
"MX124",
"MX125",
"MX126",
"MX127",
"MX128",
"MX129",
"MX130",
"MX131",
"MX132",
"MX133",
"MX134",
"MX135",
"MX136",
"MX137",
"MX138",
"MX139",
"MX140",
"MX141",
"MX142",
"MX143",
"MX144",
"MX145",
"MX146",
"MX147",
"MX148",
"MX149",
"MX150",
"MX151",
"MX152",
"MX153",
"MX154",
"MX155",
"MX156",
"MX157",
"MX158",
"MX159",
"MX160",
"MX161",
"MX162",
"MX163",
"MX164",
"MX165",
"MX166",
"MX167",
"MX168",
"MX169",
"MX170",
"MX171",
"MX172",
"MX173",
"MX174",
"MX175",
"MX176",
"MX177",
"MX178",
"MX179",
"MX180",
"MX181",
"MX182",
"MX183",
"MX184",
"MX185",
"MX186",
"MX187",
"MX188",
"MX189",
"MX190",
"MX191",
"MX192",
"MX193",
"MX194",
"MX195",
"MX196",
"MX197",
"MX198",
"MX199",
"MX200"]
		
			//console.log('CALLING IF');
			if (values.avatar) {
				values.avatar = 'https://firebasestorage.googleapis.com/v0/b/curso-demencia.appspot.com/o/avatar-doctor.jpg?alt=media';
			}
			if(values.other === undefined){
				values.other = ""
			}
			if(values.subpeciality === undefined){
				values.subpeciality = ""
			}
			//if(codes.indexOf(values.code) != -1){
			//if(values.age)
			this.setState({ sex: values.sex});
			if(codes.indexOf(values.code) != -1){
			this.setState({  state: values.state });
			//console.log('CALLING LOADER');
			//this.props.showAuthLoader();
			
			this.setState({ values: values });
			var age = values.age
			values.age = age.format("DD/MM/YYYY")
			values.email = values.email.toLowerCase()
			
			console.log(values);
			database.collection('users').where('email', '==', values.email).get().then(function(snapshot) {
				if (snapshot.docs.length == 0) {
					//console.log(Moment().format("DD/MM/YYYY'T'hh:mm:ss"))
					if(values.password.length >= 6){
					values.registration_date = Moment().format("DD/MM/YYYY'T'hh:mm:ss")
					database
						.collection('users')
						.add(values)
						.then(function(docRef) {
							console.log('WRITING USER DATA DONE');
							_this.props.userSignUp(values);
						})
						.catch(function(error) {
							//console.error('Error adding document: ', error);
						});
				} else {
					console.log('Short Password');
					message.error('La contraseña debe de tener al menos 6 caracteres');

					//_this.props.alertMessage = 'Este usuario ya esta registrado';
				}
			}else{
				message.error('Este usuario ya esta registrado');
			
			}
			});
		}else{
			message.error('Código de registro incorrecto');
		}
		} else {
			//console.log('ERROR IS NOT NULL');
		}
	};

	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			this.handleSignIn(err, values);
			////console.log(moment(values.birthdate).format('MM/DD/YYYY'));
		});
	};

	constructor() {
		super();
		this.state = {
			loading: false,
			state: 'Aguascalientes',
			sex: 'Masculino',
			redirect: false,
			signing: false,
			values: {}
			//email: 'demo@example.com',
			//password: 'demo#123'
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.setRedirect = this.setRedirect.bind(this);
		this.handleSignIn = this.handleSignIn.bind(this);
		this.handleSexClick = this.handleSexClick.bind(this);
		this.handleStateClick = this.handleStateClick.bind(this);
	}

	componentDidMount() {
		this.setState({ state: 'Aguascalientes', sex: 'Masculino' });
	}

	componentDidUpdate() {
		//console.log("V1.233")
		if (this.props.showMessage) {
			setTimeout(() => {
				this.props.hideMessage();
			}, 100);
		}

		//console.log(this.props);
		//console.log(this.state);
		if (!this.state.signing) {
			if (this.props.authUser !== null) {
				auth.onAuthStateChanged((user) => {
					if (user) {
						//console.log('AUTH USER IS ALL RIGHT');
						//this.props.history.push('/');
						//console.log('redirecting...');
						this.setRedirect();
					} else {
						if (this.state.values.email && this.state.values.password) {
							var _this = this;
							this.setState({ signing: true });
							//console.log(this.props.authUser);
							//console.log('AUTH USER IS NOT NUL BUT FIREBASE IS; SIGNING IN....');
							auth
								.signInWithEmailAndPassword(this.state.values.email, this.state.values.password)
								.then((authUser) => {
									this.props.history.push('//');
								})
								.catch((error) => error);
						} else {
							//console.log('EMPTY VALUES');
						}
					}
				});
			} else {
				//console.log('AUTH USER IS NULL');
			}
		}
	}

	render() {
		const { getFieldDecorator } = this.props.form;
		const { showMessage, loader, alertMessage } = this.props;

		const imageUrl = this.state.imageUrl;
		return (
			<div className="gx-app-login-wrap" >
			<HorizontalDefault/>
			<div className="gx-app-login-wrap" id="login-cont">

				<div className="gx-app-login-container">
				
					<div className="gx-app-login-main-content">
						
						{this.renderRedirect()}

						<div className="gx-app-login-content">
						<Row><Col span="6"></Col><Col span="12">		
						 <img alt="example" src={require('assets/images/asset_3.png')} /> 	<br></br>	<br></br>	<br></br>
						</Col><Col span="6"></Col>
					
						</Row>
							{/* <Row>
								<Col span="8" />
								<Col span="8">
									{' '}
								 <img alt="example" src={require('assets/images/asset_3.png')} /> 
								</Col>
								<Col span="8" />
							</Row>
							<br /> */}
							<Form onSubmit={this.handleSubmit} className="gx-signup-form gx-form-row0">
								<Row>
									<Col xl={12} lg={12} md={12} sm={12} xs={12}>
										<FormItem>
											{getFieldDecorator('name', {
												rules: [ { required: true, message: 'Por favor escribe tu nombre' } ]
											})(<Input placeholder="Nombre" />)}
										</FormItem>
										<FormItem>
											{getFieldDecorator('paternal_lastname', {
												rules: [ { required: true, message: 'Ingrese su apellido paterno' } ]
											})(<Input placeholder="Apellido Paterno" />)}
										</FormItem>

										<FormItem>
											{getFieldDecorator('maternal_lastname', {
												rules: [ { required: true, message: 'Ingrese su apellido materno' } ]
											})(<Input placeholder="Apellido Materno" />)}
										</FormItem>
										
										<FormItem>
											{getFieldDecorator('sex', {
												rules: [ { required: true, message: 'Por favor seleccione su sexo' } ]
											})(
												<Select
													name="sex"
													onChange={this.handleSexClick}
													value={this.state.sex}
													placeholder="Sexo"
												>
													<Option value="Masculino">Masculino</Option>
													<Option value="Femenino">Femenino</Option>
												</Select>
											)}
										</FormItem>
										<FormItem>
											{getFieldDecorator('age', {
												rules: [
													{
														required: true,
														message: 'Por favor seleccione su fecha de nacimiento'
													}
												]
											})(
												<DatePicker
													className="gx-mb-3 gx-w-100"
													showTime={false}
													showToday={false}
													format="DD/MM/YYYY"
													placeholder="Fecha de nacimiento"
								 				/>
											)}
										</FormItem>
										
										<FormItem>
											{getFieldDecorator('state', {
												rules: [ { required: true, message: 'Por favor ingrese su estado' } ]
											})(
												<Select
													name="state"
													onChange={this.handleStateClick}
													value={this.state.state}
													placeholder="Estado"
												>
													<Option value="Aguascalientes">Aguascalientes</Option>

													<Option value="Baja California">Baja California</Option>

													<Option value="Baja California Sur">Baja California Sur</Option>

													<Option value="Campeche">Campeche</Option>

													<Option value="Coahuila de Zaragoza">Coahuila</Option>

													<Option value="Colima">Colima</Option>

													<Option value="Chiapas">Chiapas</Option>

													<Option value="Chihuahua">Chihuahua</Option>

													<Option value="Ciudad de México">Ciudad de México</Option>

													<Option value="Durango">Durango</Option>

													<Option value="Guanajuato">Guanajuato</Option>

													<Option value="Guerrero">Guerrero</Option>

													<Option value="Hidalgo">Hidalgo</Option>

													<Option value="Jalisco">Jalisco</Option>

													<Option value="México">México</Option>

													<Option value="Michoacán">Michoacán</Option>

													<Option value="Morelos">Morelos</Option>

													<Option value="Nayarit">Nayarit</Option>

													<Option value="Nuevo León">Nuevo León</Option>

													<Option value="Oaxaca">Oaxaca</Option>

													<Option value="Puebla">Puebla</Option>

													<Option value="Querétaro">Querétaro</Option>

													<Option value="Quintana Roo">Quintana Roo</Option>

													<Option value="San Luis Potosí">San Luis Potosí</Option>

													<Option value="Sinaloa">Sinaloa</Option>

													<Option value="Sonora">Sonora</Option>

													<Option value="Tabasco">Tabasco</Option>

													<Option value="Tamaulipas">Tamaulipas</Option>

													<Option value="Tlaxcala">Tlaxcala</Option>

													<Option value="Veracruz">Veracruz</Option>

													<Option value="Yucatán">Yucatán</Option>

													<Option value="Zacatecas">Zacatecas</Option>
												</Select>
											)}
										</FormItem>
											
										<FormItem>
											{getFieldDecorator('city', {
												rules: [ { required: true, message: 'Ingrese su ciudad' } ]
											})(<Input placeholder="Ingrese su ciudad" />)}
										</FormItem>	
										</Col>
												<Col xl={12} lg={12} md={12} sm={12} xs={12}>
										<FormItem>
											{getFieldDecorator('license', {
												rules: [ { required: true, message: 'Ingrese su cédula' } ]
											})(<Input placeholder="Ingrese su cédula" />)}
										</FormItem>	
									
										<FormItem>
											{getFieldDecorator('speciality', {
												rules: [ { required: true, message: 'Ingrese su especialidad' } ]
											})(<Input placeholder="Ingrese su especialidad" />)}
										</FormItem>
										<FormItem>
											{getFieldDecorator('subpeciality', {
												rules: [ { required: false, message: 'Ingrese su subespecialidad' } ]
											})(<Input placeholder="Ingrese su subespecialidad" />)}
										</FormItem>
									
											
								
										<FormItem>
											{getFieldDecorator('code', {
												rules: [ { required: true, message: 'Ingrese su código' } ]
											})(<Input placeholder="Código de registro" />)}
										</FormItem>
										{/* <span>Fotografía de perfil</span> */}

										{/* <FormItem>
									{getFieldDecorator('avatar', {
										rules: [
											{
												required: false,
												message: 'Please upload your avatar!'
											}
										]
									})(
										<Upload
											name="avatar"
											listType="picture-card"
											className="avatar-uploader"
											showUploadList={false}
											//action="//jsonplaceholder.typicode.com/posts/"
											beforeUpload={this.beforeUpload}
											onChange={this.handleChange}
										>
											{imageUrl ? <img src={imageUrl} alt="avatar" /> : uploadButton}
										</Upload>
									)}
								</FormItem> */}
										<FormItem>
											{getFieldDecorator('email', {
												rules: [
													{
														required: true,
														type: 'email',
														message: 'The input is not valid E-mail!'
													}
												]
											})(<Input placeholder="Email" />)}
										</FormItem>
										<FormItem>
											{getFieldDecorator('password', {
												rules: [ { required: true, message: 'Please input your Password!' } ]
											})(<Input type="password" placeholder="Password" />)}
										</FormItem>
									</Col>
								</Row>
								<FormItem>
									{getFieldDecorator('remember', {
										valuePropName: 'checked',
										initialValue: true
									})(
										<Checkbox>
											<IntlMessages id="appModule.iAccept" />
										</Checkbox>
									)}
									<span className="gx-link gx-signup-form-forgot">
									<a className="gx-login-form-forgot" href="https://www.cardiometabolica-siegfried.com/aviso" target="_blank">	<IntlMessages id="appModule.termAndCondition" /></a>

									
									</span>
								</FormItem>
								
								<FormItem>
									<Button
									id="sesion"
										type="primary"
										className="gx-mb-0"
										htmlType="submit"
										onClick={this.handleSubmit}
									>
										<IntlMessages id="app.userAuth.signUp" />
									</Button>
									<span>
										<IntlMessages id="app.userAuth.or" />
									</span>{' '}
									<Link to="/signin">
										<IntlMessages id="app.userAuth.signIn" />
									</Link>
								</FormItem>
							</Form>
						</div>

						{loader && (
							<div className="gx-loader-view">
								<CircularProgress />
							</div>
						)}
						{showMessage && message.error(alertMessage)}
					</div>
					<span id="version-code">
				{version}</span>
				</div>
				</div>
				<img class="footer-image" src={require("assets/images/ACOMODO-new.png")} alt="cardiometabolica-siegfried" title="cardiometabolica-siegfried"/>

			</div>
		);
	}
}

const WrappedSignUpForm = Form.create()(SignUp);

const mapStateToProps = ({ auth }) => {
	const { loader, alertMessage, showMessage, authUser } = auth;
	return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
	userSignUp,
	hideMessage,
	userSignIn,
	showAuthLoader,
	userFacebookSignIn,
	userGoogleSignIn,
	userGithubSignIn,
	userTwitterSignIn
})(WrappedSignUpForm);
